import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DashboardComponent } from "./dashboard.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ToggleButtonModule } from "primeng/togglebutton";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { SharedModule } from "../../shared/shared.module";
import { SelectButtonModule } from "primeng/selectbutton";
import { SubscriptionPlansModule } from './subscription-plans/subscription-plans.module';
import { RouterModule } from '@angular/router';
import { NgChartsModule } from 'ng2-charts';

@NgModule({
    declarations: [
        DashboardComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        CardModule,
        ToggleButtonModule,
        BreadcrumbModule,
        SharedModule,
        SelectButtonModule,
        SubscriptionPlansModule,
        RouterModule,
        NgChartsModule,
    ],
    exports: [
        DashboardComponent,
    ],
})
export class DashboardModule {}
